/* eslint-disable no-unused-vars */
import { connect } from 'react-redux';
import React,{ useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Button, Typography, withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import queryString from 'query-string';

// Get user to know if user is logged in or not
import { getUserDetails } from '../../../reducers/portalConfig';
import { getI18n } from '../../../utils/intl';
import styles from './styles';
import { getThemes } from '../../../reducers/portalConfig';
import WarningIcon from '../icons/warningIcon.svg';
import { get } from 'lodash';


const LoginConfirmation = ( props ) => {
  const { classes, themes } = props;
  const intl = getI18n(useIntl());
  const { logo, siteTitle } = themes;
  useEffect(()=> {
    const user = props.userContexts;
    if(user) {
      window.location.href = '/admin';
    }
  }, []);
  const getRedirectUrl = () => {
    const queryParam = queryString.parse(props.location.search);
    return get(queryParam, 'redirectUrl');
  };
  const navigateToHome = () => {
    window.location.href = '/admin/homeRedirect';
  };
  const reAuthenticate = () => {
    let redirectUrl = getRedirectUrl();
    if(redirectUrl && redirectUrl.includes('?token=')) {
      redirectUrl = `${redirectUrl}&terminateExistingSessions=true`;
    } else {
      redirectUrl = `${redirectUrl}?terminateExistingSessions=true`;
    }
    const queryParam = queryString.parse(props.location.search);
    const fromUrl = get(queryParam, 'fromUrl');
    if(fromUrl) {
      redirectUrl = `${redirectUrl}&fromUrl=${encodeURIComponent(fromUrl)}`;
    }
    window.location.href = redirectUrl;
  };
  return (
    <div className={classes.parentContainer}>
      <div className={classes.content}
        id="request-details-page" data-apim-test="request-details-page"
      >
        <div className={classes.container} >
          <img
            className={classes.logoImage}
            alt="Logo"
            src={logo}
          />
        </div>
        <Typography variant="h1" className={classes.pageTitle}>
          {siteTitle}
        </Typography>
        <div className={classes.warningAndSubTitle}>
          <img
            src={WarningIcon}
            className={classes.warningIcon}
            alt="Compliance Warning"
          />
          <Typography variant="h3" className={classes.pageTitle}>
            {intl.getI18nFormattedMessage('label.login.saml.confirm.sub.title')}
          </Typography>
        </div>
        <Typography variant="body1">
            {intl.getI18nFormattedMessage('label.login.saml.confirm.helper.text')}
        </Typography>
        <Button
            className={classes.actionButton}
            data-apim-test="re-authenticate-button"
            id='re-authenticate-button'
            variant="contained"
            color="secondary"
            onClick={reAuthenticate}
            disabled={false}
          >
            {intl.getI18nFormattedMessage('label.login.saml.confirm.reauth.button')}
        </Button>
        <Button
            className={classes.actionButton}
            data-apim-test="cancel-button"
            id='cancel-button'
            variant="outlined"
            color="secondary"
            onClick={navigateToHome}
          >
            {intl.getI18nFormattedMessage('label.login.saml.confirm.cancel')}
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userContexts: getUserDetails(state),
  themes: getThemes(state),
});

LoginConfirmation.propTypes = {
  classes: PropTypes.object,
  getThemes: PropTypes.func,
  themes: PropTypes.object,
  location: PropTypes.object,
  userContexts: PropTypes.object,
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(LoginConfirmation);
